import React, { useState } from "react";
import { Box, Flex, Text, Icon, Divider, Stack } from "@chakra-ui/react";
import {
  BadgeCheck,
  BadgeInfo,
  BadgeX,
  Calendar,
  Clock,
  Bell,
  Info,
  Users,
  Mailbox,
} from "lucide-react";
import ReusableAvatar from "components/Avatar/ReusableAvatar";

const ViewNotification = ({ notification }) => {
  if (!notification) return null;

  return (
    <Flex direction="column" p={8} width="100%">
      {/* Header with Avatar and Basic Info */}
      <Flex justifyContent="space-between" alignItems="center">
        <Flex alignItems="center">
          <ReusableAvatar name={notification.userId} />
          <Box>
            <Text
              fontSize="2xl"
              fontWeight="bold"
              display="flex"
              alignItems="center"
            >
              {notification.userId}
              {notification.status === "Sent" && (
                <>
                  <Icon
                    as={BadgeCheck}
                    size={12}
                    color="green.500"
                    stroke="white"
                    ml={1}
                    fill="green.500"
                  />
                  <Text color="green.500" fontWeight="xs" fontSize="13px">
                    {" "}
                    Sent
                  </Text>
                </>
              )}
              {notification.status === "Pending" && (
                <>
                  <Icon
                    as={BadgeInfo}
                    size={12}
                    color="yellow.500"
                    stroke="white"
                    ml={1}
                    fill="yellow.500"
                  />
                  <Text color="yellow.500" fontWeight="xs" fontSize="13px">
                    {" "}
                    Pending
                  </Text>
                </>
              )}
              {notification.status === "Archived" && (
                <Icon
                  as={BadgeX}
                  size={12}
                  color="red.500"
                  stroke="white"
                  ml={1}
                  fill="red.500"
                />
              )}
            </Text>
            <Text fontSize="sm" color="gray.500" mt={1}>
              {notification.notificationType}
            </Text>
          </Box>
        </Flex>
      </Flex>

      <Flex mt={2} alignItems="center">
        <Icon as={Calendar} size={16} color="gray.500" mr={1} />
        {notification.scheduledDate ? (
          <Text fontSize="sm" color="gray.500" mr={4}>
            Scheduled Date: {notification.scheduledDate}
          </Text>
        ) : (
          <Text fontSize="sm" color="gray.500" mr={4}>
            Date Sent: {notification.sentAt}
          </Text>
        )}
      </Flex>

      <Divider my={6} />

      <Flex direction="column" p={4}>
        {/* Notification Title */}
        <Text fontSize="lg" fontWeight="bold" mb={2}>
          {notification.title}
        </Text>

        {/* Notification Details */}
        <Box mb={6}>
          <Stack spacing={4}>
            <Flex
              alignItems="center"
              border="1px"
              borderColor="gray.300"
              borderRadius="md"
              p={2}
            >
              <Icon as={Bell} mr={2} color="gray.400" />
              <Text fontWeight="500" color="gray.500" fontSize="sm">
                Type: {notification.notificationType}
              </Text>
            </Flex>
           
            <Flex
              alignItems="center"
              border="1px"
              borderColor="gray.300"
              borderRadius="md"
              p={2}
            >
              <Icon as={Users} mr={2} color="gray.400" />
              <Text fontWeight="500" color="gray.500" fontSize="sm">
                Target Users: {notification.targetUsers.join(", ")}
              </Text>
            </Flex>
            <Box
              border="1px"
              borderColor="gray.300"
              borderRadius="md"
              p={6}
              display="flex"
              alignItems="center"
            >
              <Icon as={Mailbox} mr={3} color="gray.400" fontSize="lg" />
              <Text fontWeight="500" color="gray.500" fontSize="md">
                Message: {notification.message}
              </Text>
            </Box>
          </Stack>
        </Box>
      </Flex>
    </Flex>
  );
};

export default ViewNotification;
